export const FOLDER_TEMPLATES = {
    nhs: [
        { key: 'business_case', name: 'Business Case' },
        { key: 'financials', name: 'Financials' },
        { key: 'contract', name: 'Contract' },
        { key: 'quotes', name: 'Quotes' },
        { key: 'plan_pid', name: 'Plan & PID' },
        { key: 'benefits', name: 'Benefits' },
        { key: 'supporting_docs', name: 'Supporting Documents' },
        { key: 'design_decisions', name: 'Design Decisions' },
        {
            key: 'transformation',
            name: 'Transformation',
            children: [{ key: 'workstreams', name: 'Workstreams' }],
        },
        {
            key: 'technical',
            name: 'Technical',
            children: [
                { key: 'technical_docs', name: 'Technical Docs' },
                { key: 'infrastructure', name: 'Infrastructure' },
                { key: 'hld', name: 'High Level Designs' },
                { key: 'integration', name: 'Integration' },
                { key: 'data_migration', name: 'Data Migration' },
                { key: 'configuration', name: 'Configuration' },
                { key: 'end_user_devices', name: 'End User Devices' },
                { key: 'printing', name: 'Printing' },
                { key: 'medical_devices', name: 'Medical Devices' },
                { key: 'reporting', name: 'Reporting (Informatics)' },
                { key: 'clinical_safety', name: 'Clinical Safety' },
            ],
        },
        { key: 'change_control', name: 'Change Control' },
        { key: 'meetings', name: 'Meetings' },
        { key: 'highlight_reports', name: 'Highlight Reports' },
        { key: 'raid_logs', name: 'RAID Logs' },
        { key: 'resource_plan', name: 'Resource Plan' },
    ],
    blank: [],
};
export const FOLDER_TEMPLATE_KEYS = Object.keys(FOLDER_TEMPLATES);
export const SHEET_TEMPLATES = {
    tracker: {
        kind: 'tracker',
        refPrefix: 'T-',
        fields: [
            { name: 'Title', role: 'title', type: 'text', options: { width: 260 } },
            { name: 'Owner', role: 'owner', type: 'user', options: { width: 130 } },
            {
                name: 'Status', // a plain dropdown here — only governed `status` columns carry the status role
                type: 'select',
                options: { choices: ['Not started', 'In progress', 'Blocked', 'Done'], width: 110 },
            },
            { name: 'RAG', role: 'rag', type: 'rag', options: { width: 70 } },
            { name: 'Due', role: 'due', type: 'date', options: { width: 95 } },
            { name: 'Updates', role: 'updates', type: 'updates', options: { width: 420 } },
        ],
    },
    raid: {
        kind: 'raid',
        refPrefix: 'RAID-',
        fields: [
            {
                name: 'Type',
                role: 'type',
                type: 'select',
                options: {
                    choices: ['Risk', 'Issue', 'Assumption', 'Dependency', 'Escalation', 'Decision'],
                    width: 95,
                },
            },
            { name: 'Title', role: 'title', type: 'text', options: { width: 250 } },
            { name: 'Workstream', role: 'workstream', type: 'select', options: { choices: [], width: 115 } },
            { name: 'Owner', role: 'owner', type: 'user', options: { width: 115 } },
            { name: 'RAG', role: 'rag', type: 'rag', options: { width: 70 } },
            // Governed: values come from each RAID type's workflow; changes are recorded as governance events.
            { name: 'Status', role: 'status', type: 'status', options: { width: 110 } },
            { name: 'Due', role: 'due', type: 'date', options: { width: 92 } },
            { name: 'Updates', role: 'updates', type: 'updates', options: { width: 440 } },
        ],
    },
    change_log: {
        kind: 'change_log',
        refPrefix: 'CR-',
        fields: [
            { name: 'Title', role: 'title', type: 'text', options: { width: 280 } },
            {
                name: 'Category',
                type: 'select',
                options: { choices: ['Scope', 'Schedule', 'Cost', 'Technical', 'Clinical', 'Contract'], width: 100 },
            },
            { name: 'Requested by', type: 'user', options: { width: 125 } },
            { name: 'Impact', type: 'select', options: { choices: ['Low', 'Medium', 'High'], width: 80 } },
            { name: 'RAG', role: 'rag', type: 'rag', options: { width: 70 } },
            // Governed by the change_request workflow (§13).
            { name: 'Status', role: 'status', type: 'status', options: { width: 130 } },
            { name: 'Updates', role: 'updates', type: 'updates', options: { width: 420 } },
        ],
    },
    // M6 (§6.3): the registers the Highlight Report is generated from — ordinary sheets, fully editable and reportable.
    workstream_status: {
        kind: 'workstream_status',
        refPrefix: 'WS-',
        fields: [
            { name: 'Workstream', role: 'workstream', type: 'select', options: { choices: [], width: 150 } },
            { name: 'Lead', role: 'owner', type: 'user', options: { width: 140 } },
            { name: 'RAG', role: 'rag', type: 'rag', options: { width: 70 } },
            { name: 'Justification', role: 'justification', type: 'text', options: { width: 420 } },
            { name: 'Updates', role: 'updates', type: 'updates', options: { width: 420 } },
        ],
    },
    milestones: {
        kind: 'milestones',
        refPrefix: 'MS-',
        fields: [
            { name: 'Milestone', role: 'title', type: 'text', options: { width: 260 } },
            { name: 'Workstream', role: 'workstream', type: 'select', options: { choices: [], width: 120 } },
            { name: 'Owner', role: 'owner', type: 'user', options: { width: 120 } },
            { name: 'Baseline', role: 'baseline', type: 'date', options: { width: 92 } },
            { name: 'Forecast', role: 'due', type: 'date', options: { width: 92 } },
            { name: 'RAG', role: 'rag', type: 'rag', options: { width: 70 } },
            {
                name: 'Progress',
                role: 'progress',
                type: 'select',
                options: { choices: ['Not started', 'On track', 'At risk', 'Complete', 'Missed'], width: 100 },
            },
            { name: 'Commentary', role: 'updates', type: 'updates', options: { width: 380 } },
        ],
    },
    finance: {
        kind: 'finance',
        refPrefix: 'FIN-',
        fields: [
            { name: 'Line item', role: 'title', type: 'text', options: { width: 240 } },
            { name: 'Workstream', role: 'workstream', type: 'select', options: { choices: [], width: 120 } },
            {
                name: 'Category',
                role: 'category',
                type: 'select',
                options: { choices: ['Capital', 'Revenue'], width: 90 },
            },
            { name: 'Budget (£)', role: 'budget', type: 'number', options: { width: 105 } },
            { name: 'Forecast (£)', role: 'forecast', type: 'number', options: { width: 105 } },
            { name: 'Actual to date (£)', role: 'actual', type: 'number', options: { width: 125 } },
            { name: 'RAG', role: 'rag', type: 'rag', options: { width: 70 } },
            { name: 'Commentary', role: 'updates', type: 'updates', options: { width: 340 } },
        ],
    },
    blank: {
        kind: 'custom',
        refPrefix: '',
        fields: [
            { name: 'Title', role: 'title', type: 'text', options: { width: 260 } },
            { name: 'Notes', type: 'text', options: { width: 300 } },
        ],
    },
};
export const SHEET_TEMPLATE_KEYS = Object.keys(SHEET_TEMPLATES);
//# sourceMappingURL=templates.js.map